import styled from 'styled-components'

import { Card as AntCard, Col, Row } from 'antd'

import bg_doixe from 'src/assets/images/bg_doixe.svg'
import bg_feedback from 'src/assets/images/bg_feedback.svg'
export const PageWrapper = styled.div`
   width: 100%;
   overflow-x: hidden;
`

export const Section = styled.section`
   padding: 44px 16px;

   @media (max-width: 768px) {
      padding: 36px 16px;
   }
`

export const Container = styled.div`
   max-width: 1400px;
   width: 100%;
   margin: 0 auto;
   padding: 0 10px;
   @media (max-width: 1024px) {
      padding: 0 32px; /* TABLET */
   }

   @media (max-width: 768px) {
      padding: 0 16px; /* MOBILE */
   }
`

/* ===== HERO ===== */

export const HeroSection = styled.section<{ bg: string }>`
   position: relative;
   width: 100%;
   min-height: 720px;
   // display: flex;
   // align-items: center;
   background: url(${(p) => p.bg}) center / cover no-repeat;
   color: #fff;

   @media (max-width: 768px) {
      min-height: auto;
      padding-top: 96px; /* tránh header */
      padding-bottom: 32px;
      align-items: flex-start;
   }
`

export const HeroTitle = styled.h1`
   font-size: 28px;
   font-weight: 600;
   color: #fff;
   margin-bottom: 12px;
   line-height: 1.2;
   @media (max-width: 960px) {
      font-size: 18px;
      line-height: 1.4;
   }
   @media (max-width: 768px) {
      font-size: 16px;
      line-height: 1.35;
   }
`

export const HeroDesc = styled.p`
   font-size: 15px;
   max-width: 520px;
   color: #fff;
`

export const HeroLayout = styled.div`
   display: flex;
   align-items: center;
   min-height: 720px;
   gap: 16px;
   @media (max-width: 768px) {
      flex-direction: column;
      align-items: stretch;
   }
`

export const HeroLeft = styled.div`
   flex: 0 0 auto;
   max-width: 420px;
   margin: auto 0; /* ✅ center theo chiều dọc */

   @media (max-width: 768px) {
      max-width: 100%;
      text-align: center;
   }
`

export const HeroRight = styled.div`
   flex: 1; /* 🔥 ăn toàn bộ phần còn lại */
   min-width: 0; /* tránh overflow form */
   margin-top: auto;
   .ant-card {
      width: 100%;
   }
`

export const ContactButton = styled.a`
   /* Layout & Alignment */

   display: inline-flex;
   align-items: center;
   justify-content: center;
   gap: 6px;
   /* Border & Padding */
   padding: 8px 16px;
   border: 1px solid #fff;
   border-radius: 4px;
   background-color: transparent;

   margin-bottom: 16px;
   /* Text Style */
   color: #fff;
   font-size: 14px;
   font-weight: 500;
   cursor: pointer;

   /* Animation */
   transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); /* Hiệu ứng hơi nảy nhẹ */

   img {
      width: 24px;
      height: 24px;
      /* Giữ nguyên màu gốc của SVG */
   }

   /* Hiệu ứng Zoom khi Hover */
   &:hover {
      transform: scale(1.08); /* Phóng to lên 8% */
      border-color: #fff; /* Giữ nguyên màu viền trắng */
      color: #fff;
   }

   /* Hiệu ứng nhấn xuống khi Click */
   &:active {
      transform: scale(0.95); /* Thu nhỏ lại một chút khi bấm vào tạo cảm giác thật */
   }

   @media (max-width: 768px) {
      font-size: 18px;
      padding: 10px 24px;

      img {
         width: 20px;
         height: 20px;
      }
   }
`
export const ContactButtonBlack = styled.a`
   /* Layout & Alignment */

   display: inline-flex;
   align-items: center;
   justify-content: center;
   gap: 6px;
   /* Border & Padding */
   padding: 8px 16px;
   border: 1px solid #000;
   border-radius: 4px;
   background-color: transparent;

   margin-bottom: 16px;
   /* Text Style */
   color: #000;
   font-size: 14px;
   font-weight: 500;
   cursor: pointer;

   /* Animation */
   transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); /* Hiệu ứng hơi nảy nhẹ */

   img {
      width: 24px;
      height: 24px;
      /* Giữ nguyên màu gốc của SVG */
   }

   /* Hiệu ứng Zoom khi Hover */
   &:hover {
      transform: scale(1.08); /* Phóng to lên 8% */
      border-color: #000; /* Giữ nguyên màu viền trắng */
      color: #000;
   }

   /* Hiệu ứng nhấn xuống khi Click */
   &:active {
      transform: scale(0.95); /* Thu nhỏ lại một chút khi bấm vào tạo cảm giác thật */
   }

   @media (max-width: 768px) {
      font-size: 18px;
      padding: 10px 24px;

      img {
         width: 20px;
         height: 20px;
      }
   }
`
/* ===== CARD ===== */

export const Card = styled.div`
   background: #fff;
   border-radius: 12px;
   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
   padding: 24px;

   @media (max-width: 768px) {
      padding: 16px;
   }
`

export const SectionTitle = styled.h2`
   font-size: 30px;
   font-weight: 700;
   text-align: center;
   margin-bottom: 48px;
   text-transform: uppercase;
   @media (max-width: 768px) {
      font-size: 24px;
      margin-bottom: 32px;
   }
`

export const StyledCard = styled(AntCard)`
   height: 100%;
   display: flex;
   flex-direction: column;
   overflow: hidden;

   .ant-card-cover {
      overflow: hidden;
   }

   .ant-card-body {
      flex-grow: 1; /* Đẩy phần body chiếm hết khoảng trống còn lại */
   }
`

export const CardImage = styled.img`
   width: 100%;
   aspect-ratio: 4 / 3; /* Cố định tỉ lệ 4:3 cho mọi ảnh */
   object-fit: cover; /* Cắt ảnh thông minh để không bị méo */
   display: block;
   transition: transform 0.3s ease;

   &:hover {
      transform: scale(1.05); /* Hiệu ứng phóng to nhẹ khi di chuột */
   }
`
export const CardBlur = styled(StyledCard)`
   border-radius: 12px;
   box-shadow: '0 6px 16px rgba(0,0,0,0.12)';
   background: rgba(0, 0, 0, 0.6);
   backdrop-filter: blur(8px);
`

export const TestimonialSection = styled(Section)`
   background: url(${bg_feedback}) center / cover no-repeat;
`
export const BgDoiXeSection = styled.section`
   background: url(${bg_doixe}) center / cover no-repeat;
   padding: 16px 16px;

   @media (max-width: 768px) {
      padding: 16px 16px;
   }
`

export const TestimonialWrap = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 48px;
   align-items: center;

   @media (max-width: 768px) {
      grid-template-columns: 1fr;
      text-align: center;
   }
`

export const TestimonialText = styled.div`
   h2 {
      font-size: 36px;
      font-weight: 700;
      margin-bottom: 16px;
      color: #000;
   }

   p {
      max-width: 420px;
      color: #000000;
   }
`

export const TestimonialCard = styled.div`
   background: #fff;
   border-radius: 16px;
   padding: 24px;
   box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
`

export const TestimonialUser = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   margin-bottom: 16px;
`

export const SliderControl = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   gap: 12px;
   margin-top: 16px;

   button {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: none;
      cursor: pointer;
      background: #f0f0f0;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
         background: #edbb1d;
         color: #fff;
      }
   }
`
